import { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, Power, PowerOff } from "lucide-react";
import { toast } from "sonner";

export function AdminInstructors() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/admin/instructors"); setItems(data); }
    catch (e) {} finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (id) => {
    setBusy(id);
    try {
      const { data } = await api.post(`/admin/instructors/${id}/toggle`);
      toast.success(data.disabled ? "Instructor disabled" : "Instructor re-enabled");
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(null); }
  };

  if (loading) return <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-arctic-primary" /></div>;

  return (
    <Card className="rounded-2xl border-border overflow-hidden">
      <Table>
        <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Active bookings</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Actions</TableHead></TableRow></TableHeader>
        <TableBody>
          {items.map((i) => (
            <TableRow key={i.user_id} data-testid={`admin-instructor-${i.user_id}`}>
              <TableCell>{i.name}</TableCell>
              <TableCell>{i.email}</TableCell>
              <TableCell>{i.active_bookings}</TableCell>
              <TableCell>
                <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold border ${i.disabled ? "bg-red-100 text-red-700 border-red-200" : "bg-emerald-100 text-emerald-800 border-emerald-200"}`}>
                  {i.disabled ? "Disabled" : "Active"}
                </span>
              </TableCell>
              <TableCell className="text-right">
                <Button variant="outline" size="sm" disabled={busy === i.user_id} onClick={() => toggle(i.user_id)} data-testid={`toggle-instructor-${i.user_id}`}
                  className={`rounded-full ${i.disabled ? "text-emerald-700 border-emerald-300" : "text-destructive border-destructive/30"}`}>
                  {busy === i.user_id ? <Loader2 className="w-4 h-4 animate-spin" /> : i.disabled ? <><Power className="w-4 h-4 mr-1" /> Enable</> : <><PowerOff className="w-4 h-4 mr-1" /> Disable</>}
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">No instructors yet. Invite one from the Invitations tab.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </Card>
  );
}
